import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely decode HTML entities (e.g. &amp; -> &, &lt; -> <)
 * Uses DOMParser instead of innerHTML to avoid XSS risks
 */
export function decodeHtmlEntities(text: string): string {
  if (!text) return text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  return doc.documentElement.textContent || text;
}
